import React, { memo, useMemo } from "react";
import "./input.css";
import { useSearch } from "../../../../../../../../../contexts/SearchContext";
import { DatePicker, Input as AntInput, Select, Typography } from "antd";
import dayjs from "dayjs";

const InputPassenger = memo(
  ({ id, title, type, passengerNum, roomNumber, values }) => {
    const { passengerInfo, setPassengerInfo } = useSearch();

    // const [currentPassengerValue, setCurrentPassengerValue] = useState(
    //   passengerInfo[roomNumber][passengerNum - 1][id]
    // );

    const currentPassengerValue = useMemo(() => {
      try {
        return passengerInfo[roomNumber][passengerNum - 1][id] || "";
      } catch (error) {
        console.error("Error accessing passengerInfo:", error);
        return "";
      }
    }, [passengerInfo, roomNumber, passengerNum, id]);

    const updatedInput = (e) => {
      const newValue = e.target.value;
      if (newValue === currentPassengerValue) {
        return;
      }
      e.preventDefault();

      // Get current room
      const passNumInArray = passengerNum - 1;

      // Deep copy passengerInfo to avoid direct mutation
      const newPassengerInfo = JSON.parse(JSON.stringify(passengerInfo));
      newPassengerInfo[roomNumber][passNumInArray][id] = e.target.value;

      // Save the changes
      setPassengerInfo(newPassengerInfo);
    };

    return (
      <div className="inputPass-component">
        <Typography.Text className="inputPass-title">{title}</Typography.Text>
        <div className="inputPass-input-wrapper">
          {type === "select" ? (
            <Select
              id={`${id}-${passengerNum}-${roomNumber}`}
              value={currentPassengerValue}
              onChange={(value) => {
                if (value === currentPassengerValue) return;
                let passInfo = passengerInfo[roomNumber];
                const passNumInArray = passengerNum - 1;
                const newPassengerInfo = JSON.parse(
                  JSON.stringify(passengerInfo)
                );
                newPassengerInfo[roomNumber][passNumInArray][id] = value;
                setPassengerInfo(newPassengerInfo);
              }}
              className="inputPass-input"
              style={{ width: "100%" }}
              options={values.map((value) => ({
                label: value.label,
                value: value.value,
              }))}
              placeholder={title}
            />
          ) : type === "date" ? (
            <DatePicker
              id={`${id}-${passengerNum}-${roomNumber}`}
              value={
                currentPassengerValue && currentPassengerValue !== ""
                  ? dayjs(currentPassengerValue, "DD/MM/YYYY")
                  : null
              }
              onChange={(date, dateString) => {
                if (dateString === currentPassengerValue) return;
                let passInfo = passengerInfo[roomNumber];
                const passNumInArray = passengerNum - 1;
                const newPassengerInfo = JSON.parse(
                  JSON.stringify(passengerInfo)
                );
                newPassengerInfo[roomNumber][passNumInArray][id] = dateString;
                setPassengerInfo(newPassengerInfo);
              }}
              className="inputPass-input"
              placeholder={title}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              required
            />
          ) : (
            <AntInput
              id={`${id}-${passengerNum}-${roomNumber}`}
              type={type}
              value={currentPassengerValue}
              onChange={updatedInput}
              className="inputPass-input"
              placeholder={title}
              required
            />
          )}
        </div>
      </div>
    );
  }
);

export default InputPassenger;
